import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-6 border-gray-200" }
const _hoisted_2 = { class: "col-span-4 flex flex-wrap gap-5 items-center" }
const _hoisted_3 = { class: "text-gray-500 text-sm font-medium leading-4 pb-2" }
const _hoisted_4 = { class: "text-sm font-medium text-gray-900 leading-4" }
const _hoisted_5 = { class: "col-span-2 flex ml-auto gap-3 pl-4" }

import { computed } from 'vue';
import { BaseCard } from '@/lib/components/Card';
import { BasePopover, PopoverButton } from '@/lib/components/Popover';
import { MedKitButton } from '@bigpicturemedical/medkit';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { EpisodeSummaryItem } from '@/models';


export default /*#__PURE__*/_defineComponent({
  __name: 'EpisodeOfCareSummary',
  props: {
    patientId: {},
    organisationId: {},
    encounterId: {},
    pathwaySlug: {},
    items: {}
  },
  emits: ["openUpdateHospitalTeamModal"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const props = __props;

const emit = __emit;

const episodeOfCareId = computed(() => route.params?.episodeOfCareId || '');
const worklistId = computed(() => route.params?.worklistId || '');

const goToReviewSubmissionPage = async () => {
  await router.push({
    name: 'ibd-review-submission',
    params: {
      organisationId: props.organisationId,
      patientId: props.patientId,
      episodeOfCareId: episodeOfCareId.value,
      worklistId: worklistId.value
    },
    query: {
      encounterId: props.encounterId,
      pathwaySlug: props.pathwaySlug
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseCard), {
    padding: "5",
    class: "py-4"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, key) => {
            return (_openBlock(), _createElementBlock("div", { key: key }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(item.label), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(item.value), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(BasePopover), null, {
            button: _withCtx(() => [
              _createVNode(_unref(MedKitButton), {
                size: "medium",
                icon: "chevron-down",
                label: _unref(t)('custom.uhb.pathways.actions'),
                "data-dusk": "actions-btn"
              }, null, 8, ["label"])
            ]),
            menu: _withCtx(() => [
              _createVNode(_unref(PopoverButton), {
                class: "focus:outline-none",
                "data-dusk": "update-hospital-team-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('openUpdateHospitalTeamModal')))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('custom.uhb.pathways.update-hospital-team')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.encounterId)
            ? (_openBlock(), _createBlock(_unref(MedKitButton), {
                key: 0,
                size: "medium",
                kind: "primary",
                label: _unref(t)('custom.uhb.review.review'),
                "data-dusk": "review-submission-btn",
                onClick: goToReviewSubmissionPage
              }, null, 8, ["label"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})